<template>
  <date-range
    v-model="value[filterKey]"
    :placeholder="options.placeholder"
    :label="options.label"
    mode="datetime"
    variant="narrow"
  />
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import DateRange from '@components/utils/inputs/DateRange.vue';

export interface Options {
  placeholder: string;
  label: string;
}

export interface Props {
  modelValue: Record<
    string,
    {
      start: Date;
      end: Date;
    }
  >;
  filterKey: string;
  options: Options;
}

const emit = defineEmits(['update:modelValue']);
const props = defineProps<Props>();
const value = useVModel(props, 'modelValue', emit, { passive: true });
</script>

<style lang="scss" scoped></style>
